/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { validDate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  MinDate,
  MaxDate,
} from '../../../../../SharedModules/CommonConstants/commonConstants';

import { addNewRowBankruptcy } from '../../store/ManufacturerAction';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../SharedModules/DateUtilities/DateUtilities';

export default (props) => {
  const dispatch = useDispatch();
  const bankruptcyRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.bankruptcyList;
  });
  const { data, isEnablebyRole } = props;
  const rowIndex =
    bankruptcyRowData?.length > 0 &&
    bankruptcyRowData?.findIndex((x) => {
      return x.id?.toString() === data?.id?.toString();
    });
  const handleChangeDate = (d) => {
    if (d?.target?.value) {
      let { value } = d?.target;
      const newObj = [...bankruptcyRowData];
      if (value && value.length > 5) {
        const data = value?.split('/');
        if (data[2]?.split('_')?.length === 3) {
          value = moment(value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value = d?.target?.value !== '' ? d.target.value : null;
        }
      }
      const { colId } = props.column;
      newObj[rowIndex].addEditRow = true;
      if (colId === 'startDate') {
        if (value === '' || value === null) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].startDate = value;
          newObj[rowIndex].startDateErr = true;
          dispatch(addNewRowBankruptcy(newObj, 'verify'));
        } else if (
          value !== null &&
          value !== '' &&
          validDate(new Date(value)) === false
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].startDate = value;
          newObj[rowIndex].startDateErr = true;
          dispatch(addNewRowBankruptcy(newObj, 'verify'));
        } else if (
          value !== null &&
          value !== '' &&
          compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
        ) {
          props.node.setDataValue(colId, value);
          newObj[rowIndex].startDate = value;
          newObj[rowIndex].startDateErr = true;
          dispatch(addNewRowBankruptcy(newObj, 'verify'));
        } else {
          if (
            props.data.endDate !== null &&
            props.data.endDate !== '' &&
            props.data.endDate !== 'Invalid date' &&
            compareTwoDatesGreaterThanOrEqual(
              new Date(props.data.endDate),
              moment(new Date(value)).add('days', 1)
            )
          ) {
            newObj[rowIndex].endDateErr = true;
          } else {
            newObj[rowIndex].endDateErr = false;
          }
          props.node.setDataValue(colId, value);
          newObj[rowIndex].startDate = value;
          newObj[rowIndex].startDateErr = false;
          dispatch(addNewRowBankruptcy(newObj, 'verify'));
        }
      } else if (
        value !== null &&
        value !== '' &&
        validDate(new Date(value)) === false
      ) {
        props.node.setDataValue(colId, value);
        newObj[rowIndex].endDate = value;
        newObj[rowIndex].endDateErr = true;

        dispatch(addNewRowBankruptcy(newObj, 'verify'));
      } else if (
        value !== null &&
        value !== '' &&
        compareTwoDatesGreaterThanOrEqual(
          value,
          moment(new Date(newObj[rowIndex].startDate)).add('days', 1)
        )
      ) {
        props.node.setDataValue(colId, value);
        newObj[rowIndex].endDate = value;
        newObj[rowIndex].endDateErr = true;
        dispatch(addNewRowBankruptcy(newObj, 'verify'));
      } else {
        props.node.setDataValue(colId, value);
        newObj[rowIndex].endDate = value;
        newObj[rowIndex].endDateErr = false;
        dispatch(addNewRowBankruptcy(newObj, 'verify'));
      }
    }
  };
  // handing on change date event
  const handleOnChangeDateFields = (d, colId) => {
    const newObj = [...bankruptcyRowData];
    if (d !== 'Invalid Date') {
      props.node.setDataValue(colId, d);
      if (colId === 'startDate') {
        newObj[rowIndex].startDate = d;
        newObj[rowIndex].startDateErr = false;
      }
      if (colId === 'endDate') {
        newObj[rowIndex].endDate = d;
        newObj[rowIndex].endDateErr = false;
      }
      addNewRowBankruptcy(newObj, 'verify');
    }
  };
  return (
    <div data-testid='mfg-bankruptcy-date-picker'>
      {props.column.colId === 'startDate' ? (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            required
            id='begin_date_net_association_bp_tab'
            data-testid='start-date'
            className={
              bankruptcyRowData &&
              bankruptcyRowData[rowIndex] &&
              bankruptcyRowData[rowIndex].startDateErr !== undefined &&
              bankruptcyRowData[rowIndex].startDateErr
                ? 'td-active-cell tBill-validate'
                : ''
            }
            label={false}
            format='MM/dd/yyyy'
            mask='__/__/____'
            minDate={MinDate}
            maxDate={MaxDate}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            placeholder='mm/dd/yyyy'
            value={props.value}
            onChange={(d) => {
              handleOnChangeDateFields(d, 'startDate');
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            onKeyDown={async (e) => {
              if (e.keyCode == 67) {
                // copy date
                await window.navigator?.clipboard.writeText(e?.target?.value);
              }
            }}
            helperText={null}
            error={null}
            disabled={!isEnablebyRole}
          />
        </MuiPickersUtilsProvider>
      ) : (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            required
            id='begin_date_net_association_bp_tab'
            data-testid='end-date'
            className={
              bankruptcyRowData &&
              bankruptcyRowData[rowIndex] &&
              bankruptcyRowData[rowIndex].endDateErr !== undefined &&
              bankruptcyRowData[rowIndex].endDateErr
                ? 'td-active-cell tBill-validate'
                : ''
            }
            minDate={moment(new Date(props.data.startDate)).add('days', 1)}
            maxDate={MaxDate}
            label={false}
            format='MM/dd/yyyy'
            mask='__/__/____'
            InputLabelProps={{
              shrink: true,
            }}
            onKeyDown={async (e) => {
              if (e.keyCode == 67) {
                // copy date
                await window.navigator?.clipboard.writeText(e?.target?.value);
              }
            }}
            placeholder='mm/dd/yyyy'
            value={props.value}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            onChange={(d) => {
              handleOnChangeDateFields(d, 'endDate');
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            helperText={null}
            error={null}
            disabled={!isEnablebyRole}
          />
        </MuiPickersUtilsProvider>
      )}
    </div>
  );
};
